import { Fragment } from 'react';
import { Text } from '@gasbuddy/react-components';
import { useTranslation } from 'react-i18next';
import BadgeWithModal from '../BadgeWithModal';
import BadgeModalContent from '../BadgeModalContent';

export default function EnterpriseBadge() {
  const { t } = useTranslation('badge');
  const imageUrl = '//static.gasbuddy.com/web/consumer/Verified_Icon.svg';
  const title = t('enterpriseBadge.title');

  return (
    <BadgeWithModal
      imageUrl={imageUrl}
      title={title}
    >
      <BadgeModalContent
        imageUrl={imageUrl}
        title={title}
        description={(
          <Fragment>
            <Text>
              {t('enterpriseBadge.description.monitoring')}
            </Text>
            <br /><br />
            <Text>
              {t('enterpriseBadge.description.engagement')}
            </Text>
          </Fragment>
        )}
      />
    </BadgeWithModal>
  );
}
